import React from 'react';
import { useTenant } from '../../../contexts/TenantContext';
import { StandardProgressBar } from './StandardProgressBar';
import { StarProgressIndicator } from './StarProgressIndicator';

interface LoaderCoreProps {
  text: string;
  mode: 'determinate' | 'indeterminate';
  progress: number;
  speed: number;
}

/**
 * Core loader component that decides whether to render a star-based
 * or standard progress indicator based on the tenant context.
 */
export const LoaderCore: React.FC<LoaderCoreProps> = ({
  text,
  mode,
  progress,
  speed,
}) => {
  const { isAddEditHost } = useTenant();

  // Use standard progress bars on addedit host
  if (isAddEditHost()) {
    return (
      <StandardProgressBar
        text={text}
        mode={mode}
        progress={progress}
        speed={speed}
      />
    );
  }

  // Use star progress indicator for other hosts
  return (
    <StarProgressIndicator
      text={text}
      mode={mode}
      progress={progress}
      speed={speed}
    />
  );
};
